import $ from 'jquery';
export default {
	init() {
		// Filtering JS lives in /functions/careers.php

		// Job Listing Hover Animations
		$('.job-listing').on('mouseover', function () {
			$(this).find('.job-title').addClass('hover');
		});
		$('.job-listing').on('mouseleave', function () {
			$(this).find('.job-title').removeClass('hover');
		});
	},
	finalize() {},
};
